import axios from "axios";
import type { AdvertisedPriceDetailsResponseProto } from "@noom/noom-contracts/noom_contracts/healthcare/service/healthcare/advertised_price_service";

import { HEALTHCARE_API } from "@modules/common/constants";

// The endpoint throws (no 2xx) when no advertised_price row is configured for the order's
// fulfillment partner/savings program combination — advertisedPrice is never absent on a
// successful response.
export const getInsuranceFulfillmentDetails = async (
  accessCode: string,
  accessToken: string,
  orderId: string
): Promise<AdvertisedPriceDetailsResponseProto> =>
  (
    await axios.get<AdvertisedPriceDetailsResponseProto>(
      `${HEALTHCARE_API}/v1/patient/${accessCode}/prescriptionOrders/${orderId}/advertisedPrice`,
      {
        headers: { Authorization: `bearer ${accessToken}` },
      }
    )
  ).data;
